// extracted by mini-css-extract-plugin
module.exports = {"noticeInformation":"NoticeInformation_noticeInformation__1q2-b"};